import { ErrorHandler, Injectable } from '@angular/core';
import { AnalyticsService } from './analytics.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private analyticsService: AnalyticsService) {}

  handleError(error: unknown): void {
    const normalizedError = error instanceof Error ? error : new Error(String(error));
    this.analyticsService.trackEvent('web_error', {
      message: (normalizedError.message || 'unknown').slice(0, 100),
      stack: (normalizedError.stack || '').slice(0, 100)
    });

    // Preserve existing console visibility for local debugging.
    console.error(normalizedError);
  }
}
